import {
  PatientPortalSystemOptions,
  PATIENT_PORTAL_SYSTEM_IDS,
} from 'types/patient-portal-system.types';

// Function to get the Patient Portal System ID based on the hostname
export function getPatientPortalSystemId(): PatientPortalSystemOptions | null {
  const { hostname } = window.location;

  const hostParts = hostname.split('.');
  if (hostParts.includes(PATIENT_PORTAL_SYSTEM_IDS.AMPLAR))
    return PATIENT_PORTAL_SYSTEM_IDS.AMPLAR;
  if (hostParts.includes(PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH))
    return PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH;

  return null;
}
